import { Button, Modal, Stack, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Box } from "@mui/material";
import { Dispatch, SetStateAction } from "react";
import SportsScoreIcon from "@mui/icons-material/SportsScore";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import SchoolIcon from "@mui/icons-material/School";

export const ModalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

interface CreationSelectionModalProps {
  createModal: boolean;
  setCreateModal: Dispatch<SetStateAction<boolean>>;
  setRegisterModal: Dispatch<SetStateAction<boolean>>;
  setDisplayLessonModal: Dispatch<SetStateAction<boolean>>;
  setDisplayTournamentModal: Dispatch<SetStateAction<boolean>>;
  betaMode: boolean;
}

function CreationSelectionModal({
  createModal,
  setCreateModal,
  setRegisterModal,
  setDisplayLessonModal,
  setDisplayTournamentModal,
  betaMode,
}: CreationSelectionModalProps) {
  return (
    <Modal
      open={createModal}
      onClose={() => {
        setCreateModal(false);
      }}
      aria-labelledby="Event Creation"
      aria-describedby="Create new event"
    >
      <Box sx={ModalStyle}>
        <Stack spacing={2}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography id="game-date" variant="h6" component="h2">
              Create New Event
            </Typography>
            <IconButton
              onClick={() => setCreateModal(false)}
              sx={{ position: "absolute", right: 8, top: 8 }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
          <Button
            variant="outlined"
            color="primary"
            onClick={() => {
              setCreateModal(false);
              setRegisterModal(true);
            }}
            sx={{ borderWidth: 2 }}
          >
            <Stack direction="row" spacing={2}>
              <SportsScoreIcon />
              <Typography color="primary" fontWeight="bold">
                Create New Game
              </Typography>
            </Stack>
          </Button>
          <Button
            variant="outlined"
            color="warning"
            onClick={() => {
              setCreateModal(false);
              setDisplayTournamentModal(true);
            }}
            sx={{ borderWidth: 2 }}
          >
            <Stack direction="row" spacing={2}>
              <EmojiEventsIcon color="warning" />
              <Typography color="warning" fontWeight="bold">
                Create New Tournament
              </Typography>
            </Stack>
          </Button>
          <Button
            variant="outlined"
            color="secondary"
            onClick={() => {
              setDisplayLessonModal(true);
              setCreateModal(false);
            }}
            sx={{ borderWidth: 2 }}
          >
            <Stack direction="row" spacing={2}>
              <SchoolIcon color="secondary" />
              <Typography color="secondary" fontWeight="bold">
                Create New Lesson
              </Typography>
            </Stack>
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
}

export default CreationSelectionModal;
